module.exports = __webpack_public_path__ + "img/Kibe37.6b242684.jpg";